// extracted by mini-css-extract-plugin
export default {"gifts":"style_gifts__BPP30","top":"style_top__7QzgN","image":"style_image__Yc6bx","list":"style_list__Yw4Kl","title":"style_title__vIt2T"};